import React from "react";
import { Container } from "react-bootstrap";
import Login from "../components/Login";

const EncourageLogin = () => {
  return (
    <Container
      className="d-flex flex-column align-items-center justify-content-center py-5"
      style={{ minHeight: "100vh", color: "#fff6d6" }}
    >
      <div style={{ width: "100%", maxWidth: 680, textAlign: "center" }}>
        <h1 className="display-5 mb-3">Welcome to Chesshood</h1>
        <p className="lead mb-4">
          Sign in to start your personalized training and continue straight to
          your next puzzle.
        </p>
      </div>

      <Login showLogin={false} />
    </Container>
  );
};

export default EncourageLogin;
